<template>
	<div class="main">
		<div class="search_con">
			<div class="search_con_top">
				<div class="search_con_top_left">
					<div class="title">
						<span>专业课程 / </span>
						<span>课程选择</span>
					</div>
				</div>
				<div class="search">
					<el-input
						class="search_input"
					  placeholder="请输入要搜索的内容"
					  v-model="input"
						size="small"
					  clearable>
					</el-input>
					<div class="search_btn" @click="gosearch">
						搜索
					</div>
				</div>
			</div>

			<div v-loading="toploading">
				<div class="search_con_down_left" ref="firContent">
					<div class="search_left_title">学段：</div>
					<div class="search_left_con"	:style="{ 'height': firMore ? textHeight : 'auto' }">
						<div v-for="(item,key) in firList" :key="item.id">
							<div :class="firIndex == item.name ? 'search_left_active' : 'search_left_normal'" @click="chooseIndex(1,key,item)">{{item.name}}</div>
						</div>
					</div>
					<div class="search_more" v-if="isShowFirMore" @click="firMore = !firMore">更多<i :class="firMore ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i></div>
				</div>
				<div class="search_con_down_left" ref="secContent" v-if="secList.length>0">
					<div class="search_left_title">年级：</div>
					<div class="search_left_con"	:style="{ 'height': secMore ? textHeight : 'auto' }">
						<div v-for="(item,key) in secList" :key="key">
							<div :class="secIndex == item.name ? 'search_left_active' : 'search_left_normal'" @click="chooseIndex(2,key,item)">{{item.name}}</div>
						</div>
					</div>
					<div class="search_more" v-if="isShowSecMore" @click="secMore = !secMore">更多<i :class="secMore ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i></div>
				</div>
				<div class="search_con_down_left" ref="thrContent" v-if="thrList.length>0">
					<div class="search_left_title">学科：</div>
					<div class="search_left_con"	:style="{ 'height': thrMore ? textHeight : 'auto' }">
						<div v-for="(item,key) in thrList" :key="key">
							<div :class="thrIndex == item.name ? 'search_left_active' : 'search_left_normal'" @click="chooseIndex(3,key,item)">{{item.name}}</div>
						</div>
					</div>
					<div class="search_more" v-if="isShowThrMore" @click="thrMore = !thrMore">更多<i :class="thrMore ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i></div>
				</div>
				<div class="search_con_down_left" ref="forContent" v-if="forList.length>0">
					<div class="search_left_title">版本：</div>
					<div class="search_left_con"	:style="{ 'height': forMore ? textHeight : 'auto' }">
						<div v-for="(item,key) in forList" :key="key">
							<div :class="forIndex == item.name ? 'search_left_active' : 'search_left_normal'" @click="chooseIndex(4,key,item)">{{item.name}}</div>
						</div>
					</div>
					<div class="search_more" v-if="isShowForMore" @click="forMore = !forMore">更多<i :class="forMore ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i></div>
				</div>
				<div class="search_con_down_left" ref="fifContent" v-if="fifList.length>0">
					<div class="search_left_title">册次：</div>
					<div class="search_left_con"	:style="{ 'height': fifMore ? textHeight : 'auto' }">
						<div v-for="(item,key) in fifList" :key="key">
							<div :class="fifIndex == item.name ? 'search_left_active' : 'search_left_normal'" @click="chooseIndex(5,key,item)">{{item.name}}</div>
						</div>
					</div>
					<div class="search_more" v-if="isShowFifMore" @click="fifMore = !fifMore">更多<i :class="fifMore ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i></div>
				</div>
			</div>
		</div>
		<div class="content_con">
			<div class="con_body"  v-loading="loading" :element-loading-text="loadingText">
				<div class="con_body_div">
					<div v-for="(kecheng,kcKey) in classList" :key="kcKey">
						<div class="item_div" @click="goDetail(kecheng)">
							<div class="item_top">
								<img class="item_img" :src="kecheng.imgUrl" />
							</div>
							<div class="item_title">
								{{kecheng.courseName}}
							</div>
							<div class="item_down">
								<div>
									学时：{{kecheng.credit}}
									<!-- <span class="item_down_span">
										学时：{{kecheng.classHour}}
									</span> -->
								</div>
								<div>
									浏览次数：{{kecheng.browseNumber}}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="pageCon">
					<el-pagination
						background
						class="mt-4"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="pageNo"
						:page-sizes="[12, 24, 32, 40]"
						:page-size="pageSize"
						layout=" prev, pager, next, sizes, jumper"
						:total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { Message } from 'element-ui';
	export default{
		data() {
			return {
				loading: false,
				loadingText: '加载中',
				toploading:false,
				kcflList:[],
				firList:[],//一级分类
				secList:[],//二级分类
				thrList:[],//三级分类
				forList:[],//四级分类
				fifList:[],//五级分类
				firIndex: '',
				secIndex: '',
				thrIndex: '',
				forIndex: '',
				fifIndex: '',
				classList: [],//课程列表
				hasLogin:false,
				userInfo:'',
				pageNo:1,
				pageSize:12,
				total:0,
				input: '',
				
				textHeight: null,  // 框中内容的高度
				isShowFirMore: false,  // 控制展开更多的显示与隐藏
				firMore: false,  // 内容状态是否打开
				isShowSecMore: false,  // 控制展开更多的显示与隐藏
				secMore: false,  // 内容状态是否打开
				isShowThrMore: false,  // 控制展开更多的显示与隐藏
				thrMore: false,  // 内容状态是否打开
				isShowForMore: false,  // 控制展开更多的显示与隐藏
				forMore: false,  // 内容状态是否打开
				isShowFifMore: false,  // 控制展开更多的显示与隐藏
				fifMore: false,  // 内容状态是否打开
			}
		},
		created() {
			this.getKCFL();
		},
		mounted() {
			this.$nextTick(() => {
				// 这里具体行数可依据需求自定义
				let lineHeight = 0.274 * document.documentElement.style.fontSize.replace('px','');
				this.textHeight = `0.274rem`
				setTimeout(()=>{
					if (this.$refs.firContent.offsetHeight > lineHeight) {
						this.isShowFirMore = true
						this.firMore = true
					} else {
						this.isShowFirMore = false
						this.firMore = false
					}
					if (this.$refs.secContent && this.$refs.secContent.offsetHeight > lineHeight) {
						this.isShowSecMore = true
						this.secMore = true
					} else {
						this.isShowSecMore = false
						this.secMore = false
					}
					if (this.$refs.thrContent && this.$refs.thrContent.offsetHeight > lineHeight) {
						this.isShowThrMore = true
						this.thrMore = true
					} else {
						this.isShowThrMore = false
						this.thrMore = false
					}
					if (this.$refs.forContent && this.$refs.forContent.offsetHeight > lineHeight) {
						this.isShowForMore = true
						this.forMore = true
					} else {
						this.isShowForMore = false
						this.forMore = false
					}
					if (this.$refs.fifContent && this.$refs.fifContent.offsetHeight > lineHeight) {
						this.isShowFifMore = true
						this.fifMore = true
					} else {
						this.isShowFifMore = false
						this.fifMore = false
					}
				},200)
			})
		},
		methods:{
			chooseIndex(index,key,obj){
				if(obj.name == '全部'){
					if(index == 1){
						this.firIndex = obj.name
						this.secList = [];
						this.thrList = [];
						this.forList = [];
						this.fifList = [];
					}else if(index == 2){
						this.secIndex = obj.name
						this.thrList = [];
						this.forList = [];
						this.fifList = [];
					}else if(index == 3){
						this.thrIndex = obj.name
						this.forList = [];
						this.fifList = [];
					}else if(index == 4){
						this.forIndex = obj.name
						this.fifList = [];
					}else if(index == 5){
						this.fifIndex = obj.name
					}
					this.getClassList();
					return
				}
				if(index == 1){
					this.firIndex = obj.name
					if(obj.id == 3){
						this.thrList = [{id:'',name:"全部"},...this.kcflList[key].children]
						this.thrIndex = this.thrList[0].name;
						this.secList = []
						this.secIndex = '';
						this.chooseIndex(3,0,this.thrList[0])
						return;
					}else{
						this.secList = [{id:'',name:"全部"},...this.kcflList[key].children]
						if(this.secList.length > 0){
							this.secIndex = this.secList[0].name;
							this.chooseIndex(2,0,this.secList[0])
						}else{
							this.secList = []
							this.thrList = []
							this.forList = []
							this.fifList = []
						}
						return;
					}
				}
				if(index == 2){
					this.secIndex = obj.name
					this.thrList = [{id:'',name:"全部"},...this.secList[key].children]
					if(this.thrList.length > 0){
						this.thrIndex = this.thrList[0].name;
						this.chooseIndex(3,0,this.thrList[0])
					}else{
						this.thrList = []
						this.forList = []
						this.fifList = []
					}
					return;
				}
				if(index == 3){
					this.thrIndex = obj.name
					this.forList = [{id:'',name:'全部'},...this.thrList[key].children]
					if(this.forList.length > 0){
						this.forIndex = this.forList[0].name;
						this.chooseIndex(4,0,this.forList[0])
					}else{
						this.forList = []
						this.fifList = []
					}
					return;
				}
				if(index == 4){
					this.forIndex = obj.name
					this.fifList = [{id:'',name:'全部'},...this.forList[key].children]
					if(this.fifList.length > 0){
						this.fifIndex = this.fifList[0].name;
						this.chooseIndex(5,0,this.fifList[0])
					}else{
						this.fifList = []
					}
					return;
				}
				if(index == 5){
					this.fifIndex = obj.name
				}
				this.getClassList();
			},
			//查询课堂分类
			getKCFL(){
				this.toploading = true
				this.$get('/user/CourseClassUserInfo/tree',{
					status: 0
				})
				.then((res) => {
					if(res.code == '200'){
						this.kcflList = res.data;
						let objfirt = {
								id: '',
								name:'全部'
						}
						this.kcflList = [objfirt,...this.kcflList]
						console.log('this.kcflList',this.kcflList);
						//初始化分类数据
						if(this.kcflList.length > 0){
							for (let i = 0; i < this.kcflList.length; i++) {
								let obj = {
									id: this.kcflList[i].id,
									name: this.kcflList[i].name
								}
								this.firList.push(obj);
							}
							this.firIndex = this.firList[0].name;
							console.log(this.firList.length,this.secList.length,this.thrList.length,this.forList.length,this.fifList.length)
						
							this.getClassList();
						}
					}else{
						this.$message({
						  message: res.msg,
						});
					}
					this.toploading = false
				})
				
			},
			//查询课程列表
			getClassList(){
				this.loading = true;
				this.$get('/user/CourseClassUserInfo/userList',{
					courseName: this.input,
					period: this.firIndex=='全部'?'':this.firIndex,
					grade: this.secIndex=='全部'?'':this.secIndex,
					discipline: this.thrIndex=='全部'?'':this.thrIndex,
					versionName: this.forIndex=='全部'?'':this.forIndex,
					volumeNumber: this.fifIndex=='全部'?'':this.fifIndex,
					current:this.pageNo,
					size:this.pageSize,
				})
				.then((res) => {
					console.log(res);
					if(res.code == '200'){
						this.classList = res.data.records;
						for (let i = 0; i < this.classList.length; i++) {
							let img = JSON.parse(this.classList[i].coverAddress).link;
							this.classList[i].imgUrl = img;
						}
						this.total = res.data.total;
					}else{
						this.$message({
						  message: res.msg,
						});
					}
					this.loading = false;
				}).catch(err => {
					this.loading = false;
				})
			},
			//进入详情
			goDetail(obj){
				console.log('点击',obj)
				let routeUrl = this.$router.resolve({
				     path:'/videoDetail/videoDetail',
				     query:{
				     	id: obj.id,
							type: '2',//1 专题  2 课程
				     }
				   });
				window.open(routeUrl.href, '_blank');
				
				//获取登录用户信息
				// this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
				// if(this.userInfo != null && this.userInfo != undefined){
				// 	this.hasLogin = true;
				// }
				// if(this.hasLogin){
					// if(obj.isFree == '0' && obj.isOrder == '0'){
					// 	// this.$confirm('是否使用'+obj.integral +'云豆观看内容', '提示', {
					// 	//   confirmButtonText: '确定',
					// 	//   cancelButtonText: '取消',
					// 	//   type: 'warning'
					// 	// }).then(() => {
						  
					// 	// }).catch(() => {
						   
					// 	// });
					// }else{
					// 	let routeUrl = this.$router.resolve({
					// 	     path:'/videoDetail/videoDetail',
					// 	     query:{
					// 	     	id: obj.id
					// 	     }
					// 	   });
					// 	window.open(routeUrl.href, '_blank');
					// }
				// }else{
				// 	//登录
				// 	this.$message({
				// 	  message: '请先登录',
				// 	  type:'error'
				// 	});
				// }
			},
			handleCurrentChange(val) {
			  this.pageNo = val;
			  this.getClassList();
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.getClassList();
			},
			gosearch(){
				this.pageNo = 1;
				this.getClassList();
			}
		}
	}
</script>

<style scoped>
	.main {
		background-color: #F0F6F9;padding-bottom: 0.4rem;
	}
	.title{
		width: 100%;height: 0.6rem;color: #000000;font-size: 0.15rem;font-weight: 400;font-family: Alibaba PuHuiTi;
		display: flex;align-items: center;
	}
	.title span:first-child{
		color: #cccccc;
	}
	.search_con{
		width: 12rem;background: #fff;display: flex;flex-direction: column;justify-content: center;padding-bottom: 0.3rem;margin: 0.4rem auto;margin-bottom: 0.25rem;
		box-shadow: 0 0 0.14rem 0 #134f9721;border-radius: 0.06rem;
	}
	.search_con_top{
		display: flex;align-items: center;justify-content: space-between;
	}
	.search_con_top_left{
		display: flex;align-items: center;margin-left: 0.3rem;
	}
	.search_left_title{
		color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.14rem;font-weight: 700;
	}
	.search_left_active{
		padding: 0.04rem 0.08rem;
		border-radius: 4px;
		background: #134f971a;
		color: #134F97;
		font-size: 0.14rem;
		font-family: Alibaba PuHuiTi;
		font-weight: 400;
		margin-left: 0.1rem;
		cursor: pointer;
	}
	.search_left_normal{
		padding: 0.04rem 0.08rem;
		font-size: 0.14rem;
		font-family: Alibaba PuHuiTi;
		font-weight: 400;
		margin-left: 0.1rem;
		color: #000000;
		cursor: pointer;
	}
	.search_left_con{
		width: 10rem;display: flex;align-items: center;flex-wrap: wrap;row-gap: 0.2rem;overflow: hidden;
	}
	.search_con_down_left{
		display: flex;margin-left: 0.3rem;margin-top: 0.24rem;align-items: center;
		overflow: hidden;
	}
	.search_more{
		color: #134f97;font-family: Alibaba PuHuiTi;font-size: 0.14rem;margin-left: 0.2rem;cursor: pointer;
	}
	.search{
		display: flex;align-items: center;margin-right: 0.3rem;
	}
	.search_input{
		width:3.45rem;height:0.33rem;line-height: 0.33rem;background: #EEEEEE;
	}
	.search_input>>>.el-input__inner{
		height: 0.33rem !important;
	}
	.search_btn{
		width: 0.76rem;height: 0.33rem;border-radius: 0.04rem;background: #FCC106;color: #ffffff;font-size: 0.14rem;
		font-family: Alibaba PuHuiTi;font-weight: 400;display: flex;align-items: center;justify-content: center;
		margin-left: 0.08rem;cursor: pointer;
	}
	.content_con{
		display: flex;justify-content: center;
	}
	.con_body{
		width: 12.3rem;padding:0 0.3rem;
	}
	.con_body_div{
		display: flex;flex-wrap: wrap;height: 8.53rem;overflow-y: auto;align-content: flex-start;
	}
	.marginR30{
		margin-right: 0.3rem;
	}
	.item_div{
		width: 2.77rem;height: 2.5rem;margin-bottom: 0.3rem;cursor: pointer;border-radius: 0.06rem;background: #ffffff;box-shadow: 0 0 0.14rem 0 #134f9721;margin: 0.15rem;
	}
	.item_top{
		width: 2.77rem;height: 1.56rem;margin-bottom: 0.08rem;border-radius: 0.06rem 0.06rem 0 0;
	}
	.item_img{
		width: 2.77rem;height: 1.56rem;border-radius: 0.06rem 0.06rem 0 0;
	}
	.item_title{
		color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.18rem;
		height: 0.45rem;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		overflow: hidden;
		-webkit-line-clamp: 2;
		padding: 0 0.1rem;
		margin-bottom: 0.08rem;
	}
	.item_down{
		width: 2.42rem;display: flex;align-items: center;justify-content: space-between;padding: 0 0.1rem;
		color: #cccccc;font-family: Alibaba PuHuiTi;font-size: 0.14rem;font-weight: 400;
	}
	.item_down_span{
		margin-left: 0.25rem;
	}
	.pageCon{
		display: flex;justify-content: flex-end;font-size: 0.14rem;
	}
</style>



// WEBPACK FOOTER //
// src/index/learnCourses.vue